import api from './client';
import ApiError from './error';

const PropertyService = {
  async getAllProperties({ params }) {
    try {
      const client = await api.getClient();
      return client.searchProperties(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
  async getProperty({ propertyCode }) {
    try {
      const client = await api.getClient();
      return client.viewProperty(propertyCode);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
  async getPropertyTransactions({ propertyCode }) {
    try {
      const client = await api.getClient();
      return client.searchPropertyTransactions(propertyCode);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
  async lookupProperty({ params }) {
    try {
      if (!params) {
        params = {};
      }

      if (params.propertyCode) {
        params.propertyCode = `${params.propertyCode}`;
      }

      if (params.address) {
        params.address = `${params.address}`;
      }

      const client = await api.getClient();
      return client.lookupProperty(params);
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default PropertyService;
